import { render, staticRenderFns } from "./VersionFooter.vue?vue&type=template&id=3d490332&scoped=true&"
import script from "./VersionFooter.vue?vue&type=script&lang=js&"
export * from "./VersionFooter.vue?vue&type=script&lang=js&"
import style0 from "./VersionFooter.vue?vue&type=style&index=0&id=3d490332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d490332",
  null
  
)

export default component.exports